import type { ConfigType } from '@plone/registry';
import weatherReducer from '../reducers/weather';

export default function installReducers(config: ConfigType) {
  config.addonReducers = {
    ...config.addonReducers,
    weather: weatherReducer,
  };

  return config;
}
